import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { reloadBustingCache } from '@demeter/lib/utils/chunk-load-error';
import { AuthService } from '@demeter/modules/auth';

export type LoadFailureVariant = 'failed' | 'signed-out';

@Component({
	selector: 'df-load-failure',
	imports: [],
	templateUrl: './load-failure.component.html',
	styleUrl: './load-failure.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadFailureComponent {
	readonly variant = input.required<LoadFailureVariant>();

	private readonly authService = inject(AuthService);

	onPrimary(): void {
		if (this.variant() === 'signed-out') {
			this.authService.login().subscribe({ error: () => reloadBustingCache() });
			return;
		}
		reloadBustingCache();
	}

	// A rejected login() (e.g. interaction_in_progress, or MSAL never finishing initialize())
	// must not leave this button a silent no-op — this screen is the app's last-resort recovery
	// surface. Falling back to a reload is always a visible, guaranteed action here.
	onSignInAgain(): void {
		this.authService.login().subscribe({ error: () => reloadBustingCache() });
	}
}
